  function addToCart(variant_id,quantity,loading,button) {
    if(button) button.classList.add('active');
    if(loading) loading.classList.remove('hidden');
    
    let sections = ['cart-drawer', 'cart-icon-bubble'];        
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        id: variant_id,
        quantity: quantity,
        sections: sections
      }),
    })
    .then((res) => res.json())
    .then((response) => { 
        const cartbtn = document.querySelector('#cart-icon-bubble');
        const cartDrawer = document.querySelector('cart-drawer');
        cartDrawer.classList.remove('is-empty');          
        cartDrawer.renderContents(response);
        // cartbtn.dispatchEvent(new Event("click", { bubbles: true })); 
       upsellRecommended();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      // Hide loader by adding 'hidden' class
      if(loading) loading.classList.add('hidden');
      if(button) button.classList.remove('active');
    });
  }

  // Footer
  function slideToggle(element) {
    if (element.style.display === "none" || element.style.display === "") {
      element.style.display = "block";
      element.style.maxHeight = element.scrollHeight + "px";
    } else {
      element.style.display = "none";
      element.style.maxHeight = null;
    }
  }
  const elements = document.querySelectorAll(".link_list_wrap:not(.content_info) .footer-block__heading");
      
  elements.forEach(element => {
    element.addEventListener('click', function() {
      const nextElement = element.nextElementSibling;
      slideToggle(nextElement);
    });
  });


document.addEventListener('DOMContentLoaded', function() {
  updateCartTimer();
  
  // Home page Marquee List and Award slider Section
  const containers = document.querySelectorAll('.scroll-container');
    if(containers.length){
      containers.forEach(function(container){
          const content = container.querySelector('.scroll-content');
          function startMarquee() {
            const containerWidth = container.offsetWidth;
            const contentWidth = content.offsetWidth;
            const timeDuration = content.getAttribute("time-duration");
            // console.log("timeDuration",timeDuration);
            
            let start = Date.now();
            const duration = timeDuration * 1000;
            // console.log("duration",duration);
            content.style.transform = 'translateX(0)';
          
            function animate() {
              const elapsed = Date.now() - start;
              const progress = elapsed / duration;
              const translateX = -contentWidth * progress;
          
              content.style.transform = `translateX(${translateX}px)`;
          
              if (progress < 1) {
                requestAnimationFrame(animate);
              } else {
                start = Date.now();
                requestAnimationFrame(animate);
              }
            }
            animate();
          }
          startMarquee();
    });
  }
  
// Header Drawer Menu
  document.querySelector(".shopify-section-group-header-group.hedear-drawer-section")?.classList.remove('hidden');
    var drawermenuBtn = document.querySelectorAll(".shopify-section-header-sticky .allmain-btn");
    // console.log("drawermenuBtn",drawermenuBtn);
    if(drawermenuBtn){
      drawermenuBtn.forEach(function(menu){
            const headerDrawerSection =  document.querySelector(".hedear-drawer-section");
            const popupOverlay = document.querySelector(".popup-overlay");
            if(menu){
              menu.addEventListener('click',function(){
                if(headerDrawerSection) headerDrawerSection.classList.add('active');
                if(popupOverlay) popupOverlay.classList.add('active');
                document.body.classList.add('overflow-hidden');
              });
            var popupCloseBtn = document.querySelector(".popup-wrap .popup-closeicon");
            if(popupCloseBtn){
              popupCloseBtn.addEventListener('click',function(){
                if(headerDrawerSection) headerDrawerSection.classList.remove('active');
                if(popupOverlay) popupOverlay.classList.remove('active');
                document.body.classList.remove('overflow-hidden');
              });
            }
          
            if(popupOverlay){
              popupOverlay.addEventListener('click',function(){
                if(headerDrawerSection) headerDrawerSection.classList.remove('active');
                if(popupOverlay) popupOverlay.classList.remove('active');
                document.body.classList.remove('overflow-hidden');
              });
            }
          }
        // });
      });
    }

    var submenuOpeners = document.querySelectorAll(".menu_item");
    if(submenuOpeners){
      submenuOpeners.forEach(function(submenuOpener){
        // console.log("submenuOpener",submenuOpener);
        submenuOpener.addEventListener('click',function(event){
          event.preventDefault()
          const menuopen = submenuOpener.querySelector('.mobilesubmenu-opener');
           menuopen.classList.toggle('active');
          var menuItem = submenuOpener.closest(".menublock-list");
          var submenuList = menuItem.querySelector(".drawer-sublist-menu");
          if (submenuList.style.display === 'block') {
              submenuList.style.display = 'none';
          } else {
              submenuList.style.display = 'block';
          }
        });
      });
    }

    var drawerFootersubmenuOpeners = document.querySelectorAll(".menu_item");
    // console.log("drawerFootersubmenuopener",drawerFootersubmenuOpeners.length);
    if(drawerFootersubmenuOpeners){
      drawerFootersubmenuOpeners.forEach(function(footerSubmenuOpener){
        // console.log("footerSubmenuOpener",footerSubmenuOpener);
        footerSubmenuOpener.addEventListener('click',function(){
          const Moremenuopen = footerSubmenuOpener.querySelector('.drawerfooter-opener');
          Moremenuopen.classList.toggle('active');
          var footermenuItem = footerSubmenuOpener.closest('.drawerfooter-mainlinklist');
          // console.log("menuItem",footermenuItem);
          var footersubMenuList = footermenuItem.querySelector(".drawerfooter-submenuul");
          if (footersubMenuList.style.display === 'block' || footersubMenuList.style.display === '') {
              footersubMenuList.style.display = 'none';
          } else {
              footersubMenuList.style.display = 'block';
          }
        });
      });
    }

  //function in global.js
  variantShowButton();
  variantsBlock();

  // Quinn Tab section
  document.querySelectorAll('.quinn-tab-section').forEach(function(section){
  var tabButtons = section.querySelectorAll(".fc-tab-wrapper .tab-title");
  var tabs = section.querySelectorAll(".fc-tabdata-wrapp");

  if(tabButtons.length){
    tabButtons.forEach(function(tabTitle){
      tabTitle.addEventListener('click', function(){

        // Remove active from buttons in this section only
        tabButtons.forEach(function(btn){ btn.classList.remove('active'); });
        tabTitle.classList.add("active");

        var currentTab = tabTitle.getAttribute("data-title");

        // Hide/show only inside this Quinn section
        tabs.forEach(function(tab){
          tab.classList.add('hiddenonquin');
          if(tab.getAttribute("data-content") == currentTab){
            tab.classList.remove('hiddenonquin');
          }
        });

      });
    });
  }
});


// Featured collection Tab section
  var tabButtons = document.querySelectorAll(".fc-tab-wrapperr .tab-title");
  if(tabButtons){
    tabButtons.forEach(function(tabTitle){
      tabTitle.addEventListener('click',function(){
       
        tabButtons.forEach(function(tabTitle){tabTitle.classList.remove('active');});
        tabTitle.classList.add("active");
        var currentTab = tabTitle.getAttribute("data-title");
        var tabs = document.querySelectorAll(".fc-tabdata-wrap");
        
        tabs.forEach(function(tab){
          tab.classList.add('hidden');
          var tabContent = tab.getAttribute("data-content");
          
          if(tabContent == currentTab){
            tab.classList.remove('hidden');
          }
        });
      });
    });
  }

//collection page custom filters
 var filterBtns = document.querySelectorAll(".custom_filters .custom_filter_btn");
  if (filterBtns.length) {
    filterBtns.forEach(function (filterBtn) {
      filterBtn.addEventListener('click', function () {
        if (filterBtn.classList.contains('all')) {
          filterBtns.forEach(function (filterBtn) {
            filterBtn.classList.remove('active');
          });
          filterBtn.classList.add('active');
          
          document.querySelector(".active-facets__button-wrapper .active-facets__button-remove").click();
        } else {
          document.querySelector(".custom_filters .custom_filter_btn.all").classList.remove('active');
          filterBtn.classList.toggle('active');
            let activeCount = 0;
             filterBtns.forEach(function (filterBtn) {
               if(filterBtn.classList.contains('active')){
                 activeCount++;
               }
             });
          // console.log("Active Count",activeCount);
            if (activeCount == 0) {
              document.querySelector(".custom_filters .custom_filter_btn.all").classList.add('active');
            }
          const tagVal = filterBtn.getAttribute("data-tag");
          var filterItems = document.querySelectorAll(".producttype .list-menu__item.facets__item input");
          filterItems.forEach(function (filterItem) {
             var value = filterItem.getAttribute("data-filter-tag");
            if (value == tagVal) {
                filterItem.click();
            }
          });
        }
      });
    });
  }


  // Avoid toggling the active class again if already done
  var checkedItems = document.querySelectorAll(".producttype .list-menu__item.facets__item input:checked");
  checkedItems.forEach(function (item) {
 var checkedvalue = item.getAttribute("data-filter-tag");
    filterBtns.forEach(function (btn) {
      if (!btn.classList.contains('all')) {
        const btnVal = btn.getAttribute("data-tag");
        document.querySelector(".custom_filters .custom_filter_btn.all").classList.remove('active');
       if (checkedvalue == btnVal) {
          btn.classList.add("active");
        }
      }else{
        document.querySelector(".custom_filters .custom_filter_btn.all").classList.remove('active');
      }
    });
  });

  // Prevent redundant active class toggles
  var productTypeFilters = document.querySelectorAll(".producttype");
  if(productTypeFilters){
    productTypeFilters.forEach(function(producttype){
      var filterItems = producttype.querySelectorAll(".list-menu__item");
      if (filterItems) {
        filterItems.forEach(function (filterItem) {
          filterItem.addEventListener("click", function () {
            var input = filterItem.querySelector("input");
            // console.log("input : ",input);
            if (input) {
              var inputValue = input.getAttribute("data-filter-tag");
              filterBtns.forEach(function (filterBtn) {
                if (!filterBtn.classList.contains('all')) {
                  const btnfilterVal = filterBtn.getAttribute("data-tag").toLowerCase();
                  if (inputValue.includes(btnfilterVal)) {
                    if(input.checked){
                       filterBtn.classList.add("active");
                      document.querySelector(".custom_filters .custom_filter_btn.all").classList.remove('active');
                    }else{
                      filterBtn.classList.remove("active");
                      let activeCount = 0;
                       filterBtns.forEach(function (filterBtn) {
                         if(filterBtn.classList.contains('active')){
                           activeCount++;
                         }
                       });
                      // console.log("Active Count",activeCount);
                      if (activeCount == 0) {
                        document.querySelector(".custom_filters .custom_filter_btn.all").classList.add('active');
                      }
                    }
                  }
                  
                }
              });
            }
          });
        });
      }
    })
  }
  var activeFilterBtns = document.querySelectorAll("facet-remove");
    if(activeFilterBtns){
      activeFilterBtns.forEach(function(activeFilterBtn){
        var activeFilterElems = activeFilterBtn.querySelectorAll("a");
        if(activeFilterElems){
          activeFilterElems.forEach(function(activeFilterElem){
            activeFilterElem.addEventListener('click',function(e){
              e.preventDefault();
             var activeFilterVal = activeFilterElem.getAttribute("data-val");
              activeFilterVal = activeFilterVal.toLowerCase();
              filterBtns.forEach(function (filterBtn) {
                if (!filterBtn.classList.contains('all')) {
                  const btnfilterVal = filterBtn.getAttribute("data-tag").toLowerCase();
                  if (activeFilterVal.includes(btnfilterVal)) {
                    filterBtn.classList.remove("active");
                      let activeCount = 0;
                      filterBtns.forEach(function (filterBtn) {
                        if(filterBtn.classList.contains('active')){
                          activeCount++;
                        }
                      });
                      // console.log("Active Count",activeCount);
                      if (activeCount == 0) {
                        document.querySelector(".custom_filters .custom_filter_btn.all").classList.add('active');
                      }
                    }
                  }
                });
            });
          });
        }
      })
    }
  
      
  var filterCloseicon = document.querySelector(".mobile-facets__header .filter-closeicon");
  // console.log("Filter Close Icon",filterCloseicon.length);
  if(filterCloseicon){
    filterCloseicon.addEventListener('click',function(){
      // console.log("close icon clicked");
      var filterMobile = document.querySelector(".mobile-facets__wrapper .mobile-facets__disclosure");
      // console.log("filterMobile",filterMobile);
      filterMobile.classList.remove('menu-opening');
      filterMobile.removeAttribute("open");
      document.body.classList.remove('overflow-hidden-mobile');
    });
  }

  document.addEventListener("click", function(event) {
    var filterMobile = document.querySelector(".mobile-facets__wrapper .mobile-facets__disclosure");
  
    // Check if the click is outside of both the '.mobile-filter-open-btn' and '.mobile-facets__main' elements
    var isClickOutsideFilterBtn = !event.target.closest('.mobile-filter-open-btn');
    var isClickOutsideFacetsMain = !event.target.closest('.mobile-facets__main');
  
    if (isClickOutsideFilterBtn && isClickOutsideFacetsMain) {
      filterMobile?.classList.remove('menu-opening');
      filterMobile?.removeAttribute("open");
      document.body.classList.remove('overflow-hidden-mobile');
    }
  });


  var customFilterBtn = document.querySelector(".facets-vertical-form .mobile-filter-open-btn");
  if(customFilterBtn){
    customFilterBtn.addEventListener('click',function(){
      var menuDrawer = document.querySelector("menu-drawer .mobile-facets__disclosure");
      menuDrawer.classList.toggle('menu-opening');
        document.body.classList.toggle('overflow-hidden-mobile');
      if(menuDrawer.hasAttribute('open')){
        menuDrawer.removeAttribute('open');
      } else {
        menuDrawer.setAttribute('open', '');
      }
    });
  }
  
// coupen section 
    var buttons = document.querySelectorAll('.couponcodebox');
    // console.log("buttons",buttons);
    if(buttons){
      buttons.forEach(function(button){
        button.addEventListener('click', function() {
          const textToCopy = button.textContent;
          // console.log("textToCopy : ",textToCopy);
          const tempTextarea = document.createElement('textarea');
          tempTextarea.value = textToCopy;
          // console.log("tempTextarea :",tempTextarea);
          document.body.appendChild(tempTextarea);
          tempTextarea.select();
          tempTextarea.setSelectionRange(0, 99999); // For mobile devices
          document.execCommand('copy');
          document.body.removeChild(tempTextarea);
  
          button.classList.add('active');
          // Remove the class after 2-3 seconds
          setTimeout(function() {
            button.classList.remove('active');
          }, 2000); // 2 seconds
        });
      });
    }

    // backtotop button
      const backToTopButton = document.querySelector('.backtotop-btn');
      window.addEventListener('scroll', function () {
        if (window.scrollY > 100) { // Adjust the scroll distance as needed
          backToTopButton.classList.add('active');
        } else {
          backToTopButton.classList.remove('active');
        }
      });
  
      backToTopButton.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // Smooth scrolling
        });
      });

  
  var offerBtn = document.querySelector(".offerbox-btn");
  if(offerBtn){
    offerBtn.addEventListener('click',function(){
      this.classList.toggle('active');
      document.querySelector(".offterbox-list").classList.toggle('hidden');
    });
  }


var videoIcons = document.querySelectorAll(".play-icon");

if (videoIcons.length > 0) {
  videoIcons.forEach(videoIcon => {
    videoIcon.addEventListener('click', function() {
      var videoTag = videoIcon.nextElementSibling;
      var videodata = videoIcon.getAttribute("videosrc");

      // Create iframe element
      var iframe = document.createElement("iframe");
      iframe.setAttribute("width", "800");
      iframe.setAttribute("height", "450");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allowfullscreen", true);
      iframe.setAttribute("allow", "autoplay; controls; encrypted-media");
      iframe.classList.add("video");  // Add 'video' class as per requirement
      // console.log(iframe,"iframe");
      // Set the video source (URL) to the iframe
      iframe.setAttribute("src", videodata);

      // Append the iframe to the video_tag container
      videoTag.appendChild(iframe);

      // Optionally hide the play icon after video starts
      videoIcon.classList.add('hidden');
    });
  });
}
  
    
//cart drawer free shiiping propgressBar
  // var threshlodElem = document.querySelector(".cart-drawer__footer .threshold_data");
  // var thresholdVal = threshlodElem.getAttribute("data-threshold");
  // var totalValue = threshlodElem.getAttribute("data-total") /100;
  // console.log("thresholdVal :",thresholdVal);
  // console.log("totalValue : ",totalValue);
  // if(totalValue < thresholdVal){
  //   console.log("total value is less");
  //   var freeshipVal = thresholdVal - totalValue;
  //   console.log("freeshipVal : ",freeshipVal);

  //   var freeshipPercentage = totalValue * 100/ thresholdVal;
  //   console.log("freeshipPercentage : ",freeshipPercentage);
  //   document.querySelector(".shippinginfobox .linebar span").style.width = freeshipPercentage + '%';
  // }
  
});
// ----------------Sticky Addtocart Button ------------
const productHeight = document.querySelector('.product__info-wrapper');
if (productHeight) {
  
const productHeightGet = productHeight.offsetHeight
const bodyElement = document.querySelector('body');

const onScroll = () => {
  const scrollPosition = window.pageYOffset;

  if (scrollPosition > productHeightGet) {
    bodyElement.classList.add('custom_button_active');
  } else {
    bodyElement.classList.remove('custom_button_active');
  }
};
window.addEventListener('scroll', onScroll);
}


const Stickybutton = document.querySelector('.sticky-addtocart-btn button.add-to-cart');
if (Stickybutton) {
  
  // console.log(Stickybutton,"Stickybutton");
  Stickybutton.addEventListener('click',function(){
    document.querySelector('.product-form__submit').click();
  });
}

 // -------------on refresh sticky button in disabled add 
const input = document.querySelector('.variantbox-col input:checked');
// console.log(input,'input');
if (input) {
  const quantity = input.getAttribute('data-quantity');
  const quantityValue = parseInt(quantity);
  const StickybuttonD = document.querySelector('.sticky-addtocart-btn button.add-to-cart');
    if (quantityValue === 0) {
        StickybuttonD.setAttribute("disabled", "disabled");
    } else {
        StickybuttonD.removeAttribute("disabled");
    }
}

document.addEventListener("DOMContentLoaded", function () {
  const targetElement = document.querySelector(".icontextlist-review-section");
  const buttonElement = document.querySelector(".sticky-addtocart-btn");

  let lastScrollPosition = window.scrollY; 
  let isElementVisible = false; 

  if (targetElement && buttonElement) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const currentScrollPosition = window.scrollY;
          const isScrollingDown = currentScrollPosition > lastScrollPosition;

          if (entry.isIntersecting) {
            if (!isElementVisible && isScrollingDown) {
              buttonElement.classList.add("active");
            }
            isElementVisible = true;
          } else {
            if (!isScrollingDown && entry.boundingClientRect.top > 0) {
              buttonElement.classList.remove("active");
            }
            isElementVisible = false;
          }

          lastScrollPosition = currentScrollPosition;
        });
      },
      {
        threshold: 0, 
      }
    );

    observer.observe(targetElement);
  }
});
